import LeadBlock from "@bmi-digital/components/lead-block";
import React from "react";
import {
  StyledLeadBlock,
  StyledLeadBlockContent,
  StyledTechSpecsLeadBlockCard
} from "../../../components/styles/ProductLeadBlock.styles";
import ProductTechnicalSpec from "../../../components/ProductTechnicalSpec";
import RichText from "../../../components/RichText";
import type { Product } from "../../../types/pim";
import type { TitleWithContentData } from "../../../components/TitleWithContent";

const TechnicalSpecifications = ({
  product,
  sidebarItems
}: {
  product: Product;
  sidebarItems: readonly TitleWithContentData[];
}) => (
  <StyledLeadBlock>
    <StyledLeadBlockContent>
      <ProductTechnicalSpec
        product={product}
        hasBottomBorder={Boolean(sidebarItems.length)}
      />
    </StyledLeadBlockContent>
    {sidebarItems.length > 1 ? (
      <StyledTechSpecsLeadBlockCard
        color="blue900"
        data-testid="technical-spec-post-it-card"
      >
        {sidebarItems.slice(1).map(({ title, content }, index) => {
          return (
            <LeadBlock.Card.Section key={`sidebar-item-${index}`}>
              <LeadBlock.Card.Heading>{title}</LeadBlock.Card.Heading>
              <LeadBlock.Card.Content>
                <RichText
                  document={content}
                  theme="secondary"
                  backgroundTheme="dark"
                  gtmLabel={title}
                />
              </LeadBlock.Card.Content>
            </LeadBlock.Card.Section>
          );
        })}
      </StyledTechSpecsLeadBlockCard>
    ) : null}
  </StyledLeadBlock>
);

export default TechnicalSpecifications;
